import React from 'react';
import clsx from 'clsx';
import {
  Element,
  FontType,
  Color,
  Button,
  Typography
} from '@americanexpress/aqx-components';
import styles from './__styles__/index.scss?modules';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import { mapUrlWithDtmLinkQuery } from 'service_modules/models/dtm-tagging';
import parseArrayToObject from 'src/universal/utils/parseArrayToObject';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';

const RenderImage = ({ breakpoint, assets, index, currIndex }) => {
  const imgObj = parseArrayToObject(assets, 'breakpoint');
  if (index === 0 || currIndex === index) {
    return (
      <LazyScrollMetricTracker>
        <Element
          Component="img"
          src={imgObj?.[breakpoint]?.url}
          alt={imgObj?.[breakpoint]?.alt}
        />
      </LazyScrollMetricTracker>
    );
  } else {
    return (
      <Element
        Component="img"
        src={imgObj?.[breakpoint]?.url}
        alt={imgObj?.[breakpoint]?.alt}
      />
    );
  }
};

const ContentUnit = ({ title, text, assets, buttons, index, currIndex }) => {
  const imgProps = {
    assets,
    index,
    currIndex
  };
  return (
    <Element className={clsx(styles.tabContent, styles[`item${index}`])}>
      <Element Component="div" className={styles.mobileImg}>
        <RenderImage breakpoint="mobile" {...imgProps} />
      </Element>
      <Element className={styles.leftText}>
        <Typography
          $family={FontType.BentonMedium}
          $size="30px"
          $lineHeight="38px"
          theme={{ color: Color.Gray06, marginBottom: 20 }}
          Component="h3"
        >
          {title}
        </Typography>

        <Typography
          $family={FontType.HelveticaRegular}
          $size="16px"
          $lineHeight="24px"
          className={styles.text}
          theme={{ color: Color.Gray06, marginBottom: 30 }}
        >
          {text}
        </Typography>
        <Button
          className={styles.ctaMain}
          onClick={() => {
            const { url, dtm } = buttons[0];
            sendDTMClickEvent(dtm);
            window.location.href = mapUrlWithDtmLinkQuery(url, dtm);
          }}
        >
          {buttons[0].text}
        </Button>
      </Element>
      <Element Component="div" className={styles.desktopImg}>
        <RenderImage breakpoint="desktop" {...imgProps} />
      </Element>
    </Element>
  );
};

export default React.memo(ContentUnit);
